/**
 * Auth configuration for Passwiser SIWE.
 * Defaults come from the repo-root `constants.js` (same as the Express demo).
 * Override with .env: VITE_API_BASE_URL, VITE_CLIENT_ID, VITE_SCOPE
 */
const walletConnectChainId = Number(import.meta.env.VITE_WALLETCONNECT_CHAIN_ID ?? '1');

export const authConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? __PASSWISER_CONSTANTS__.API_BASE_URL,
  clientId: import.meta.env.VITE_CLIENT_ID ?? __PASSWISER_CONSTANTS__.CLIENT_ID,
  scope: import.meta.env.VITE_SCOPE ?? __PASSWISER_CONSTANTS__.SCOPE,
  walletConnectProjectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID,
  walletConnectChains: [Number.isFinite(walletConnectChainId) ? walletConnectChainId : 1],
  redirectUri: typeof window !== 'undefined'
    ? window.location.origin + window.location.pathname
    : '',
};
